/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by randysorensen on 8/10/16,
 * Refactored by kyang on 9/25/2019
 */

function MetadataItemsSearchViewController (
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $routeParams: JS5Object,
    BreadcrumbService: JS5Object,
    MetadataItemsViewDataTransformerFactory: JS5Object,
    MetadataItemsSearchViewService: JS5Object,
) {

    //================//
    // Template Logic //
    //================//

    this.headerTitle = () => {
        switch(this.currentTab) {
            case 'package':
                return 'Package Metadata';
            case 'conversion':
                return 'Conversion Template Variables';
            default:
                return 'Non-Package Metadata';
        }
    };

    this.onTabSelect = (tabName: string) => {
        switch(tabName) {
            case 'package':
                $location.path('/system/metadataItems/package');
                break;
            case 'conversion':
                $location.path('/system/metadataItems/conversion');
                break;
            default:
                $location.path('/system/metadataItems/nonPackage');
                break;
        }
    };

    this.getPropertiesPromise = () => {
        if (this.currentTab === 'conversion') {
            return MetadataItemsSearchViewService.getMetadataProperties('nonPackage', true);
        }
        return MetadataItemsSearchViewService.getMetadataProperties(this.currentTab, false);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.currentTab = $routeParams.type;
        this.columnDefs = MetadataItemsViewDataTransformerFactory[`${this.currentTab}Columns`];
    };
}

angular.module('prism-ui.metadataItems').component(
    'metadataItemsSearchView',
    {
        bindings: {},
        controller: MetadataItemsSearchViewController,
        templateUrl: 'system/metadata/searchView/metadata-items-searchview-template.html'
    });
